import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BoardType } from 'src/app/core/models/board-type.model';
import { User } from 'src/app/core/models/user.model';
import { UserType } from 'src/app/core/models/userType.models';
import { BoardService } from 'src/app/core/services/board.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})

/**
 * Dashboard Component
 */
export class FileUploadComponent implements OnInit {
  public files: any[] = [];

  constructor(private boardService: BoardService, private router: Router) {
  }

  // bread crumb items
  breadCrumbItems: Array<{}>;

  async ngOnInit(): Promise<void> {
    this.breadCrumbItems = [{ label: 'Fortune' }, { label: 'Board Type', active: true }];
  }

  async onFileListDropped(fileList: FileList) {
    console.log('onFileListDropped(): called', {fileList, beforAddFiles: [...this.files]});
    for(let i = 0; i < fileList.length; i++) {
      const file = fileList.item(i)
      if(!this.fileListContains(file)){
        this.files.push(file)
      }
    }
    console.log('onFileListDropped(): after add', {afterAddFiles: this.files});
  }

  onDelete(index: number) {
    this.files.splice(index, 1);
  }
  
  async onSubmit() {
    await this.boardService.uploadFiles(this.files);
    this.router.navigate(['/boards'])
  }

  formatBytes(numBytes: any, decimals = 2) {
    if(numBytes === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const exp = Math.floor(Math.log(numBytes)/Math.log(k));
    return `${parseFloat((numBytes/Math.pow(k, exp)).toFixed(dm))} ${sizes[exp]}`;
  }

  async uploadHandler(event: any) {
    console.log("uploadHandler(event: any)", {event})
    await this.onFileListDropped(event);
  }

  fileListContains(file: File): boolean {
    for(const f of this.files) {
      if(
        f.name == file.name &&
        f.lastModified == file.lastModified &&
        f.size == file.size &&
        f.type == file.type
      ) {
        return true;
      }
    }
    return false;
  }
}
